import React from 'react';
import  BottomNavbar  from './bottomNavbar';

class BottomNavbarParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return <BottomNavbar {...this.props} />
    }
}

export default BottomNavbarParent;